export enum MatchTilePlayer {
  CurrentUser,
  Opponent,
  Owner,
}
